import React,{ useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {ReactComponent as VoidIcon} from '../icons/void.svg';
import LoadingModal from "../components/LoadingModal";
import { adminServices } from "../services/AdminServices";
import ImageModal from "../components/ImageModal";
import SearchBar from "../components/SearchBar";
import Button from "../components/Button";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import withAuthorization from "../components/withAuthorization";
import { formatCurrency } from "../tools/tool";
import InputText1 from "../components/InputText1";
import { logExport } from "../services/ExportLogService";

const VoidTransactions = () => {
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedRefNo, setSelectedRefNo] = useState(null);
    const [imageTitle, setImageTitle] = useState('');
    const [modalReason, setModalReason] = useState('');

    const customTableStyles = {
        table: {
            style: {
                tableLayout: 'fixed'
            }
        },
        cells: {
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word'
            }
        }
    };

    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);

    useEffect(() => {
        setLoading(true);
        getVoidTransactions();
    },[]);

    
    const exportToCSV = async (data) => {
  if (!data || data.length === 0) return;

  // Log the export
  await logExport('Void Transactions');

  const headers = [
    'Voided Date',
    'Amount',
    'Transaction Date',
    'Void Reason',
    'Voucher/Reference No',
    'PDL No',
    'PDL Name',
    'Transaction',
    'Voided By'
  ];

  const rows = data.map(row => [
    new Date(row.voided_date).toLocaleString(),
    row.amount, // raw value, no formatting
    new Date(row.transaction_date).toLocaleString(),
    row.reason,
    row.ref_no,
    row.pdl_number,
    row.pdl_name,
    row.transaction_type,
    row.voided_by
  ]);

  const csvContent = [headers, ...rows]
    .map(row => row.map(field => `"${field}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', 'VoidedTransactions.csv');
  link.click();
};
    
    const getVoidTransactions = async ()=>{
        const call = dateFrom && dateTo
          ? adminServices.storeProcedure2("void_transaction_range", {
              dateFrom: dateFrom,
              dateTo: dateTo
            })
          : adminServices.storeProcedure2("void_transactions", {});

        await call.then((r)=>{
            setLoading(false);
            setData(r.data);
            setFilteredData(r.data);
            let _col = [
                { name: 'Voided Date', selector: row=>new Date(row.voided_date).toLocaleString(), sortable: true, grow: 1 },
                { name: 'Amount', selector: row=>formatCurrency(row.amount), sortable: true, right:true, grow: 0, headerStyle: { textAlign: 'center' } },
                { name: 'Transaction Date', selector: row=>new Date(row.transaction_date).toLocaleString(), sortable: true, grow: 1 },
                { name: 'Void Reason', selector: row=>row.reason, sortable: true, grow: 2, cell: row => (
                    <div style={{whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', maxWidth: '100%'}} title={row.reason || ''}>
                        {row.reason ? (row.reason.length > 20 ? (row.reason.slice(0,20) + '...') : row.reason) : ''}
                    </div>
                )},
                { name: 'Voucher/Reference No', selector: row=>row.ref_no, sortable: true, grow: 1, cell: row => (
                    row.ref_no ? (
                        <a
                            href="#"
                            role="button"
                            className="btn btn-xs btn-link p-0 d-inline-block"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSelectedRefNo(row.ref_no); setImageTitle(`Attachment ${row.ref_no}`); setModalReason(row.reason || ''); setShowImageModal(true); }}
                            title={`View attachment for ${row.ref_no}`}
                            aria-label={`View attachment for ${row.ref_no}`}
                        >
                            {row.ref_no}
                        </a>
                    ) : null
                ), ignoreRowClick: true, allowOverflow: true },
                { name: 'PDL No', selector: row=>row.pdl_number, sortable: true, grow: 1 },
                { name: 'PDL Name', selector: row=>row.pdl_name, sortable: true, grow: 2, cell: row => <div style={{whiteSpace:'normal', wordBreak:'break-word'}}>{row.pdl_name}</div> },
                { name: 'Transaction', selector: row=>row.transaction_type, sortable: true, grow: 1, cell: row => <div style={{whiteSpace:'normal'}}>{row.transaction_type}</div> },
                { name: 'Voided By', selector: row=>row.voided_by, sortable: true, grow: 1, cell: row => <div style={{whiteSpace:'normal'}}>{row.voided_by}</div> },
            ]
                
                
            setColumns(_col);
        }).catch((e)=>{
            //console.log(e);
        });
    }

    return (
        <div className="container p-0">
            <LoadingModal show={loading} message={"Loading Void Transactions..."} />
            <div className="sc-fPXMhL QAQQD" style={{fontSize:'1.5rem', fontWeight:'bold', marginBottom:10, display: 'flex', justifyContent:'start',alignItems:'center'}}>
                <VoidIcon style={{ width: "50px", height: "50px", marginRight: "10px" }} />
                <h3>Void Transactions</h3>
            </div>

            <div className="flexRow" style={{width:'50%'}}>
                <InputText1 title={"Date From"} type="date" value={dateFrom} onChange={(e)=>{
                    setDateFrom(e.target.value);
                }}  />

                <InputText1 title={"Date To"} type="date" value={dateTo} onChange={async(e)=>{
                    setDateTo(e.target.value);
                }}  />

                <div style={{marginTop:18}}>
                    <Button variant={"primary"} onClick={()=> { getVoidTransactions() }}>Search</Button>
                </div>

            </div>

            <div className="flexRow">
                <div className="flexRow filterDiv">
                <SearchBar
                    placeholder="Search Voided Transactions"
                    onChange={(e)=>{
                    const value = e.target.value.toLowerCase();
                    const filtered = data.filter(item => 
                        Object.keys(item).some(key => 
                        item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase()) 
                        ) 
                    );
                    setFilteredData(filtered);

                    let gT = filtered.reduce((total, item) => total + item.gross_amount, 0)
                    // setGrandTotal( gT ) ;
                    }}
                />
                </div>
                &nbsp;&nbsp;
                <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-end",
                }}
                >
                </div>
                <div className="spacer"></div>
                <Button variant={"success"} size={'xs'} onClick={()=>exportToCSV(filteredData)}> Export to CSV </Button>
            </div>

            
            <br />
            <ImageModal show={showImageModal} referenceNo={selectedRefNo} extraText={modalReason} title={imageTitle} remarksLabel={"Full Reason"} onClose={() => { setShowImageModal(false); setSelectedRefNo(null); setModalReason(''); }} />
            <DataTable
                columns={columns}
                data={filteredData}
                onRowClicked={(row) => { setSelectedRefNo(row.ref_no || null); setImageTitle(row.ref_no ? `Attachment ${row.ref_no}` : 'Attachment'); setModalReason(row.reason || ''); setShowImageModal(true); }}
                pagination={false}
                striped
                persistTableHead
                pointerOnHover
                highlightOnHover
                customStyles={customTableStyles}
            />
        </div>);

};

export default withAuthorization(VoidTransactions,6);